import { useState } from "react";
import { supabase } from "../lib/supabaseClient.js";

interface AddFarmModalProps {
  open: boolean;
  onClose: () => void;
  onFarmAdded: () => void;
  userId: string;
}

export default function AddFarmModal({
  open,
  onClose,
  onFarmAdded,
  userId,
}: AddFarmModalProps) {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [area, setArea] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.from("farms").insert([
      {
        user_id: userId,
        name,
        location,
        area: Number(area),
      },
    ]);
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      setName("");
      setLocation("");
      setArea("");
      onFarmAdded();
      onClose();
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <form
        className="w-full max-w-md p-8 bg-white shadow-lg rounded-xl"
        onSubmit={handleSubmit}
      >
        <h2 className="mb-4 text-xl font-bold">Add New Farm</h2>
        <div className="mb-3">
          <label className="block mb-1 font-medium">Farm Name</label>
          <input
            className="w-full p-2 border rounded"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="block mb-1 font-medium">Location</label>
          <input
            className="w-full p-2 border rounded"
            value={location}
            onChange={e => setLocation(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="block mb-1 font-medium">Area (acres)</label>
          <input
            type="number"
            className="w-full p-2 border rounded"
            value={area}
            onChange={e => setArea(e.target.value)}
            min={0}
            step={0.1}
            required
          />
        </div>
        {error && <div className="mb-2 text-red-500">{error}</div>}
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            className="px-4 py-2 bg-gray-200 rounded"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-white bg-green-600 rounded"
            disabled={loading}
          >
            {loading ? "Saving..." : "Add Farm"}
          </button>
        </div>
      </form>
    </div>
  );
}